import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getComingNomenclatureAdjustmentDetailOne: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclatureAdjustmentDetail/${data.id}`,
      }),
    }),
    getComingNomenclatureAdjustmentDetailList: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/comingNomenclatureAdjustment/${data.id}/details`,
      }),
    }),
    changeComingNomenclatureAdjustmentDetail: builder.mutation<void, any>({
      query: (data) => ({
        url: `/v1/ComingNomenclatureAdjustmentDetail/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createComingNomenclatureAdjustmentDetail: builder.mutation<void, any>({
      query: (data) => ({
        url: '/v1/ComingNomenclatureAdjustmentDetail',
        method: 'POST',
        body: data,
      }),
    }),
    deleteComingNomenclatureAdjustmentDetail: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclatureAdjustmentDetail/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeComingNomenclatureAdjustmentDetailMutation,
  useCreateComingNomenclatureAdjustmentDetailMutation,
  useDeleteComingNomenclatureAdjustmentDetailMutation,
  useGetComingNomenclatureAdjustmentDetailListQuery,
  useGetComingNomenclatureAdjustmentDetailOneQuery,
  useLazyGetComingNomenclatureAdjustmentDetailListQuery,
  useLazyGetComingNomenclatureAdjustmentDetailOneQuery,
} = request;
